import React from 'react';
import {get} from 'lodash';
import className from 'classnames';
import moment from 'moment';

import DotTooltip from './DotTooltip';
import OverflowH from './OverflowH';
import TableHeader from './TableHeader';

class VipSignedUpList extends React.Component {
  static propTypes = {
  };

  render = () => {
    return (
      <React.Fragment>
        <div className='MainHeader'>
          <div className='MainHeader__left'>
            <h2 className='MainHeader__h2'>VIP signed up list</h2>
            <p className='MainHeader__left__p'>Total {get(this.props, 'total', 0).toLocaleString()} users</p>
          </div>
        </div>

        <div className='Table Table--vip-signed-up'>
          {(() => {
            const columnHeaders = [
              {
                label: 'User ID',
                sortKey: 'user_id',
              },
              {
                label: 'Username',
              },
              {
                label: 'Bio',
              },
              {
                label: 'Reported count',
                sortKey: 'reported_count',
              },
              {
                label: 'Last logged in',
                sortKey: 'last_loggedin_at',
              },
              {
                label: 'VIP Until',
                sortKey: 'vip_until',
              },
            ]

            return (
              <div className='Table__row'>
                {columnHeaders.map((header, key) => (
                  <TableHeader
                    key={key}
                    header={header}
                  />
                ))}
              </div>
            )
          })()}

          {get(this.props, 'users', []).map((user) => (
            <div
              className={className('Table__row', {
                'Table__row--active': get(this.state, 'checkIds', []).includes(user.id),
              })}
              key={user.id}
              data-x={user}
            >

              <div className='Table__col'>
                <DotTooltip
                  user={user}
                />
              </div>

              <div className='Table__col'>{get(user, 'username')}</div>

              <div className='Table__col'>
                <OverflowH
                  text={get(user, 'biography')}
                />
              </div>

              <div className='Table__col'>{get(user, 'reportedCount', 0)}</div>

              <div
                className='Table__col'
                dangerouslySetInnerHTML={
                  {
                    __html: get(user, 'lastLoggedinAt') !== null ?
                      moment(get(user, 'lastLoggedinAt')).format('YYYY-MM-DD<br />HH:mm')
                    :
                      'N/A'
                  }
                }
              />

              <div
                className='Table__col'
                dangerouslySetInnerHTML={
                  {
                    __html: get(user, 'vipUntil') !== null ?
                      moment(get(user, 'vipUntil')).format('YYYY-MM-DD<br />HH:mm')
                    :
                      'N/A'
                  }
                }
              />

            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default VipSignedUpList;
